import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/Login'
import Config from '@/pages/Config'
import WaitScreen from '@/pages/WaitScreen'
import Home from '@/pages/Home'
import ProductItem from '@/pages/ProductItem'
import Checkout from '@/pages/Checkout'
import Payment from '@/pages/Payment'
import Pager from '@/pages/Pager'
import ErrorScreen from '@/pages/ErrorScreen'
import BalancaScreen from '@/pages/BalancaScreen'
import ConsumerName from '../pages/ConsumerName.vue'
import Identification from '@/pages/Identification'
import ClarityController from '@/assets/controllers/ClarityController'
import MaintenancePage from '@/pages/MaintenancePage'
Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'WaitScreen',
            component: WaitScreen
        },
        {
            path: '/home',
            name: 'Home',
            component: Home
        },
        {
            path: '/productitem',
            name: 'ProductItem',
            component: ProductItem
        },
        {
            path: '/checkout',
            name: 'Checkout',
            component: Checkout
        },
        {
            path: '/pager',
            name: 'Pager',
            component: Pager
        },
        {
            path: '/payment',
            name: 'Payment',
            component: Payment
        },
        {
            path: '/login',
            name: 'Login',
            component: Login
        },
        {
            path: '/config',
            name: 'Config',
            component: Config
        },
        {
            path: '/error',
            name: 'ErrorScreen',
            component: ErrorScreen
        },
        {
            path: '/balanca',
            name: 'BalancaScreen',
            component: BalancaScreen
        },
        {
            path: '/consumer',
            name: 'ConsumerName',
            component: ConsumerName
        },
        {
            path: '/identification',
            name: 'Identification',
            component: Identification
        },
        {
            path: '/maintenance',
            name: 'MaintenancePage',
            component: MaintenancePage
        }
    ]
})
router.afterEach((to) => {
    setTimeout(() => {
        if (to.path === '/') {
            ClarityController.event('sessao_totem_finalizada')
        } else {
            ClarityController.event(`navegou_para_${to.name}`)
            ClarityController.setTag('url_atual', to.path)
        }
    }, 100)
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js